import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { buildSecondLifeMarketRouteUrl } from "./second-life-market.util";

/** Redirige a `/second-life` conservando query params y hash del navegador. */
export const secondLifeMarketRedirectGuard: CanActivateFn = () =>
    inject(Router).parseUrl(buildSecondLifeMarketRouteUrl());
